// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"111":"4e6f1894","264":"81d62c06","453":"c373949b","510":"8326d19c","862":"45ddf652","979":"aed69236"}[chunkId] + ".chunk.js";
};